/**
 * Thrown for every non 2xx response. `errors` holds the per field messages the
 * gateway sends back for validation problems, so forms can show them inline.
 */
export class TabFileError extends Error {
    name = 'TabFileError';
    status;
    title;
    detail;
    type;
    instance;
    errors;
    /** The parsed body, whatever shape it had. */
    body;
    constructor(init) {
        super(init.detail ? `${init.title}: ${init.detail}` : init.title);
        this.status = init.status;
        this.title = init.title;
        this.detail = init.detail;
        this.type = init.type;
        this.instance = init.instance;
        this.errors = init.errors ?? [];
        this.body = init.body;
    }
    /** True when the caller should sign in again. */
    get isAuthError() {
        return this.status === 401;
    }
    /** Field messages keyed by field name, for react-hook-form. */
    fieldErrors() {
        const out = {};
        for (const item of this.errors) {
            if (item.field && item.message)
                out[item.field] = item.message;
        }
        return out;
    }
}
const DEFAULT_TITLES = {
    400: 'The request was not valid',
    401: 'Sign in again to continue',
    403: 'You do not have access to this',
    404: 'Not found',
    409: 'That request conflicts with one already made',
    413: 'Too many records in one request',
    422: 'Some records did not pass the checks',
    429: 'Too many requests, slow down',
    500: 'Something went wrong on our side',
    503: 'The service is busy, try again shortly',
};
function isProblem(value) {
    return typeof value === 'object' && value !== null;
}
/** Builds a TabFileError from a status plus whatever body came back. */
export function toTabFileError(status, body, statusText) {
    const fallbackTitle = DEFAULT_TITLES[status] ?? statusText ?? `Request failed with status ${status}`;
    if (!isProblem(body)) {
        return new TabFileError({ status, title: fallbackTitle, body });
    }
    const problem = body;
    const errors = Array.isArray(problem.errors) ? problem.errors : undefined;
    return new TabFileError({
        status: typeof problem.status === 'number' ? problem.status : status,
        title: typeof problem.title === 'string' && problem.title.length > 0 ? problem.title : fallbackTitle,
        detail: typeof problem.detail === 'string' ? problem.detail : undefined,
        type: typeof problem.type === 'string' ? problem.type : undefined,
        instance: typeof problem.instance === 'string' ? problem.instance : undefined,
        errors,
        body,
    });
}
//# sourceMappingURL=errors.js.map